import React, { useEffect, useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/GetApp";
import dashboardServices from "../../services/hoa-dashboard-api-service";
import {  Box, Skeleton, Stack } from "@mui/material";

const EmailViewContainer = ({view, loading, selectedValues}: any) => {
    const [url, setUrl] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [loadingBody, setLoadingBody] = useState(false);

    const downloadAttachment = async (fileName: string) => {
        if(selectedValues.objectId){
            let path = `${'hoaEmails'}/${fileName}`;
            let bucketName = 'hoa-dashboard';
            const signedUrl = await dashboardServices.getSignedUrl(path, bucketName);
            window.open(signedUrl.data, "_blank");
        }
    }


    const loadEmailBody = async () => {
        setLoadingBody(true);
        if((Array.isArray(selectedValues.attachmentDetails))&& selectedValues.attachmentDetails.length > 0){
            let file = selectedValues.attachmentDetails.find((file: any) => file?.split('.')[1] === 'txt');
    
            let path = `${'hoaEmails'}/${file}`;
            const documentUrl = await dashboardServices.getSignedUrl(path, 'hoa-dashboard', false, true);
            if(file && documentUrl){
                setUrl(documentUrl.data)
            }
        }
        setLoadingBody(false);
    }

    useEffect(() => {
        loadEmailBody();
    },[selectedValues])

    useEffect(() => {
        if(Array.isArray(selectedValues.attachmentDetails)){
            let files = selectedValues.attachmentDetails.filter((file: any) => {
                if(file?.split('.')[1] != 'txt') return file;
            })
            setDocuments(files)
        }
    }, [selectedValues])


    return(
        <div className="mail-assign-container">
            <div className="mail-assign-pdf-container" style={{overflow: 'scroll'}}>
                <div className="sub-title-text">{selectedValues.subject}</div>
                <span className="helperText">Sent on {selectedValues.emailServerTime}</span>
                <div 
                    className="text-303030-16px normal" 
                    style={{marginTop: '24px', height: '450px', paddingBottom: '24px', borderBottom: '1px solid #E8E8E8'}}>
                    
                    {
                        !url && loadingBody ?
                        <Box>
                                <Skeleton animation="wave" />
                                <Skeleton animation="wave" />
                                <Skeleton animation="wave" />
                                <Skeleton animation="wave" />
                                <Skeleton animation="wave" />
                        </Box>
                        : !url && !loadingBody ? <p>There is no Email body!!!</p>
                        :
                        <object data={url} type="text/*" style={{ width: "100%", height: '450px'}}>
                            <div className='m-3'>
                                <p>
                                    Your browser does not support viewing this file.
                                    You can <a href={url} target="_blank">click here to download the file</a >.
                                </p> 
                            </div>
                        </object>
                    }
                        
                </div>
                
                <div style={{marginTop: '24px'}}>
                    <div className="sub-title-text">Documents</div>
                    {
                        documents.map((file: any, index: number) => (
                            <div style={{ cursor: "pointer" }} className="ov-pdf-container" onClick={()=>downloadAttachment(file)} key={index}>
                                <Stack direction={"row"} alignItems={"center"}>
                                    <PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
                                    <span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">{file?.split('-')?.pop()}</span>
                                </Stack>
                                <DownloadIcon style={{ width: "20px", height: "20px", color: "#3576E5" }} />
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="mail-assign-property-container" style={{overflowY: 'scroll', width: '56%'}}>
                <span className="text-3E3E3E-18px">Basic Information</span>
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    <Stack
                        style={{ marginRight: "64px", marginTop: "24px" }}
                        direction="column"
                    >
                        <span className="text-787878-14px bold">Email Type</span>
                        <span
                            style={{ marginTop: "10px" }}
                            className="text-303030-16px normal"
                        >
                            {selectedValues.emailType || 'N/A'}
                        </span>
                    </Stack>
                    <Stack
                        style={{ marginRight: "64px", marginTop: "24px" }}
                        direction="column"
                    >
                        <span className="text-787878-14px bold">Sent From</span>
                        <span
                            style={{ marginTop: "10px" }}
                            className="text-303030-16px normal"
                        >
                            {selectedValues.sendFrom ? selectedValues.sendFrom.join(', ') : 'N/A'}
                        </span>
                    </Stack>
                </Stack>

                <div className="sub-title-text" style={{ marginTop:"24px", paddingBottom: '10px' }}>Assigned Property</div>
                {
                    !Array.isArray(selectedValues.propertyList) && (
                        <div className="assigned-property-container">
                            <span className="text-303030-16px normal">No property assigned yet !</span>
                        </div>
                    )
                }
                {
                    Array.isArray(selectedValues.propertyList) && selectedValues.propertyList.map((property: any) => (
                        <div className="assigned-property-container">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <div className="text-303030-16px normal">External Id: {property?.hoaPropertyDetails?.externalId}</div>
                            </div>
                            <div style={{ color: "#3576E5", fontSize: 16, fontWeight: 400, boxShadow: "inset 0px -1px 0px #E8E8E8" }}>
                                <div style={{ marginBottom: 24 }}>{property?.fullAddress}</div>
                            </div>
                            <Stack
                                style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                                direction={"row"}
                                flexWrap={"wrap"}
                            >
                                <Stack
                                    style={{ marginRight: "64px", marginTop: "24px" }}
                                    direction="column"
                                >
                                    <span className="text-787878-14px bold">Market</span>
                                    <span
                                        style={{ marginTop: "10px" }}
                                        className="text-303030-16px normal"
                                    >
                                        {property?.hoaPropertyDetails?.market || "N/A"}
                                    </span>
                                </Stack>
                                {["city", "state"].map(
                                    (title: string, index: number) => {
                                        return (
                                            <Stack
                                                key={index}
                                                style={{ marginRight: "64px", marginTop: "24px" }}
                                                direction="column"
                                            >
                                                <span className="text-787878-14px bold">{title}</span>
                                                <span
                                                    style={{ marginTop: "10px" }}
                                                    className="text-303030-16px normal"
                                                >
                                                    {property?.info[title] || 'N/A'}
                                                </span>
                                            </Stack>
                                        );
                                    }
                                )}
                            </Stack>
                        </div>

                    ))
                }
            </div>
        </div>
    )
}

export default EmailViewContainer;